export const bookList = [
  {
    typeName: "著作集",
    resType: 0,
    groupId: 46,
    list: [
      // {shId:'gJowg',overdue:false,coverImgUrl:'//imgb2.chineseall.cn/bookcover/157/150/984/61421339_st_300_400.jpg',name:'习近平谈治国理政（第三卷）',author:'习近平著',intro:'《习近平谈治国理政》第三卷收入了习近平总书记在2017年10月18日至2020年1月13日期间的报告、讲话、谈话、演讲、批示、指示、贺信等92篇，分为19个专题。',url:'/book/detail/gJowg',wUrl:'/book/detail/gJowg'}
      {
        shId: "CVWOg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/701/959/139/80073759_st_300_400.jpg",
        name: "习近平谈治国理政（第三卷）",
        author: "习近平著",
        intro:
          "《习近平谈治国理政》第三卷收入了习近平总书记在2017年10月18日至2020年1月13日期间的报告、讲话、谈话、演讲、批示、指示、贺信等92篇，分为19个专题。",
        url: "/book/detail/CVWOg",
        wUrl: "/book/detail/CVWOg",
      },
      {
        shId: "kNu6j",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/351/956/387/61523227.jpg",
        name: "论坚持人民当家作主",
        author: "习近平著",
        intro:
          "我国是工人阶级领导的、以工农联盟为基础的人民民主专政的社会主义国家，国家一切权力属于人民。人民当家作主是社会主义民主政治的本质和核心。党的十八大以来，以习近平同志为核心的党中央坚持人民主体地位，积极发展社会主义民主政治，党的领导、人民当家作主、依法治国有机统一的制度建设全面加强，党的领导体制机制不断完善，社会主义民主不断发展，党内民主更加广泛，社会主义协商民主全面展开，爱国统一战线巩固发展，民族宗教工作创新推进，有力促进了改革开放和社会主义现代化建设，有力维护了国家统一、民族团结、社会稳定。坚持人民当家作主，是习近平新时代中国特色社会主义思想的重要组成部分，对于坚持中国特色社会主义政治发展道路，推进全过程人民民主建设，完善和发展中国特色社会主义制度、推进国家治理体系和治理能力现代化，夺取全面建设社会主义现代化国家新胜利、实现中华民族伟大复兴的中国梦，具有十分重要的指导意义。为了帮助广大干部群众深入学习习近平同志关于坚持人民当家作主的重要论述，中央党史和文献研究院将习近平同志的相关论述汇编为《论坚持人民当家作主》一书。本书收入党的十八大以来习近平同志关于坚持人民当家作主的文稿共五十篇，其中部分文稿是首次公开发表。",
        url: "/book/detail/kNu6j",
        wUrl: "/book/detail/kNu6j",
      },
      {
        shId: "Foowg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/910/933/752/61427077_st_300_400.jpg",
        name: "论中国共产党历史",
        author: "习近平著",
        intro:
          "历史是最好的教科书。党的十八大以来，习近平同志围绕中国共产党历史发表了一系列重要论述，系统回顾我们党团结带领中国人民不懈奋斗的光辉历程，深入总结党在各个历史时期创造的理论成果、积累的宝贵经验、铸就的伟大精神，深刻阐明党为中华民族作出的伟大贡献、为解决全人类问题提供的中国智慧中国方案，展望党和人民事业发展的光明前景。这些重要论述立意高远，内涵丰富，思想深刻，对于我们学好党的历史，增强“四个意识”、坚定“四个自信”、做到“两个维护”，决胜全面建成小康社会、开启全面建设社会主义现代化国家新征程、实现中华民族伟大复兴的中国梦，具有十分重要的指导意义。为了帮助广大干部群众深入学习习近平同志关于中国共产党历史的重要论述，我们将习近平同志的相关论述汇编为《论中国共产党历史》一书。本书收入党的十八大以来习近平同志关于中国共产党历史的文稿共四十篇，其中部分文稿是首次公开发表。",
        url: "/book/detail/Foowg",
        wUrl: "/book/detail/Foowg",
      },
    ],
  },
  {
    typeName: "讲话单行本",
    resType: 0,
    groupId: 47,
    list: [
      // {shId:'Qoowg',overdue:false,coverImgUrl:'//imgb2.chineseall.cn/bookcover/942/965/784/61427109.jpg',name:'加强政党合作 共谋人民幸福——在中国共产党与世界政党领导人峰会上的主旨讲话',author:'习近平著',intro:'2021年7月6日，中共中央总书记、国家主席习近平在北京以视频连线方式出席中国共产党与世界政党领导人峰会，并发表题为《加强政党合作 共谋人民幸福》的主旨讲话。他指出，中国共产党成立100年来，团结带领中国人民接续奋斗，推动中华民族迎来了从站起来、富起来到强起来的伟大飞跃。中国共产党坚持中国人民和世界各国人民命运与共，在世界大局和时代潮流中把握中国发展的前进方向、促进各国共同发展繁荣。他强调，政党作为推动人类进步的重要力量，要锚定正确的前进方向，担起为人民谋幸福、为人类谋进步的历史责任。中国共产党愿同各国政党一起努力，始终不渝做世界和平的建设者、全球发展的贡献者、国际秩序的维护者。',url:'/book/detail/Qoowg',wUrl:'/book/detail/Qoowg'}
      // ,{shId:'yJowg',overdue:false,coverImgUrl:'//imgb2.chineseall.cn/bookcover/941/964/783/61427108.jpg',name:'在庆祝中国共产党成立100周年大会上的讲话',author:'习近平著',intro:'2021年7月1日上午，庆祝中国共产党成立100周年大会在北京人民大会堂隆重举行。中共中央总书记、国家主席、中央军委主席习近平在会上发表重要讲话。习近平总书记的重要讲话被广大党员干部群众称为“一堂十分生动的党课”。历史反复证明，只有坚守马克思主义信仰，坚定共产主义远大理想，坚持中国特色社会主义道路自信、理论自信、制度自信、文化自信，党才能带领人民群众在实现中华民族伟大复兴的道路上不断取得新的胜利。',url:'/book/detail/yJowg',wUrl:'/book/detail/yJowg'}
      // ,{shId:'Apowg',overdue:false,coverImgUrl:'//imgb2.chineseall.cn/bookcover/937/960/779/61427104.jpg',name:'在党史学习教育动员大会上的讲话',author:'习近平著',intro:'本书为习主席在党史学习教育动员大会上的讲话。习主席强调，开展党史学习教育意义重大。我们党历来重视党史学习教育。在庆祝我们党百年华诞的重大时刻，在“两个一百年”奋斗目标历史交汇的关键节点，在全党集中开展党史学习教育，正当其时，十分必要。在全党开展党史学习教育，是牢记初心使命、推进中华民族伟大复兴历史伟业的必然要求，是坚定信仰信念、在新时代坚持和发展中国特色社会主义的必然要求，是推进党的自我革命、永葆党的生机活力的必然要求。',url:'/book/detail/Apowg',wUrl:'/book/detail/Apowg'}
      {
        id: 1513866,
        assetsId: 61547642,
        shId: "GKu6j",
        overdue: false,
        url: "/book/detail/GKu6j",
        wUrl: "/book/detail/GKu6j",
        name: "在第十七届中国—东盟博览会和中国—东盟商务与投资峰会开幕式上的致辞（汉英对照）",
        intro:
          "2020年11月27日，第十七届中国—东盟博览会和中国—东盟商务与投资峰会在广西南宁举行，习近平主席在开幕式上发表视频致辞，全面回顾近年来中国同东盟合作取得的丰硕成果，高度评价中国—东盟关系具有的典范意义，明确提出了建设更为紧密的中国—东盟命运共同体的4点倡议。为更好地向国内外宣传、阐释习近平总书记在致辞中提出的“建设更为紧密的中国—东盟命运共同体”重要观点，外文出版社出版《在第十七届中国—东盟博览会和中国—东盟商务与投资峰会开幕式上的致辞》中英对照版，以进一步宣介习近平新时代中国特色社会主义思想、展示中国主场外交取得的成就，展示中国在全球治理中贡献的中国智慧和中国方案。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/838/596/922/61547642_st_300_400.jpg",
        author: "习近平著",
        publisher: "外文出版社",
        publishDate: "2021年10月",
        price: "20.00",
        isbn: "978-7-119-12792-7",
        dueDate: "2025-05-31",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
        id: 1513867,
        assetsId: 61547643,
        shId: "eKu6j",
        overdue: false,
        url: "/book/detail/eKu6j",
        wUrl: "/book/detail/eKu6j",
        name: "凝心聚力，继往开来　携手共谱合作新篇章——在中国—中东欧国家领导人峰会上的主旨讲话（汉英对照）",
        intro:
          "2021年2月9日，习近平主席在北京以视频方式主持中国—中东欧国家领导人峰会，此次峰会是2021年我国首场主场外交，是中国—中东欧国家合作机制建立以来举行的最高级别领导人会晤，也是在全球共同抗击新冠肺炎疫情背景下举行的重要国际多边活动。为更好地向国内外宣传、阐释本次峰会重要成果，我社出版《凝心聚力，继往开来 携手共谱合作新篇章——在中国—中东欧国家领导人峰会上的主旨讲话》中英对照版，以进一步宣介习近平新时代中国特色社会主义思想、展示中国主场外交取得的成就，展示中国在全球治理中贡献的中国智慧和中国方案。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/839/597/923/61547643_st_300_400.jpg",
        author: "习近平著",
        publisher: "外文出版社",
        publishDate: "2021年10月",
        price: "20.00",
        isbn: "978-7-119-12791-0",
        dueDate: "2025-05-31",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
        id: 1513869,
        assetsId: 61547645,
        shId: "iEu6j",
        overdue: false,
        url: "/book/detail/iEu6j",
        wUrl: "/book/detail/iEu6j",
        name: "加强政党合作，共谋人民幸福——在中国共产党与世界政党领导人峰会上的主旨讲话（汉英对照）",
        intro:
          "中国共产党与世界政党领导人峰会于7月6日以视频连线方式举行，中共中央总书记、国家主席习近平在北京出席会议并发表主旨讲话。此次峰会是庆祝中国共产党成立100周年大会后，习近平总书记首次面向国际社会、特别是面向全球政党阐述中国共产党对人类前途命运的关切和关心，积极回应各国政党对中国共产党的期待，并同与会世界主要政党和政治组织领导人一道，共商团结合作与未来发展大计。此次峰会也是中国共产党迄今主办的规格最高、规模最大的全球性政党峰会，这在中国共产党对外交往史和世界政党发展史上具有里程碑式的重要意义。本书以中英对照形式收录本篇主旨讲话。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/841/599/925/61547645_st_300_400.jpg",
        author: "习近平著",
        publisher: "外文出版社",
        publishDate: "2021年10月",
        price: "20.00",
        isbn: "978-7-119-12836-8",
        dueDate: "2025-05-31",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
    ],
  },
  {
    typeName: "论述摘编",
    resType: 0,
    groupId: 48,
    list: [
      {
        shId: "yoowg",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/911/934/753/61427078.jpg",
        name: "习近平关于注重家庭家教家风建设论述摘编",
        author: "中共中央党史和文献研究院编",
        intro:
          "家庭是社会的基本细胞，家庭的前途命运同国家和民族的前途命运紧密相连。党的十八大以来，习近平同志围绕注重家庭、注重家教、注重家风建设发表的一系列重要论述，立意高远，内涵丰富，思想深刻，对于动员社会各界广泛参与家庭文明建设，努力使千千万万个家庭成为国家发展、民族进步、社会和谐的重要基点，把实现个人梦、家庭梦融入国家梦、民族梦之中，汇聚起全面建设社会主义现代化国家、实现中华民族伟大复兴中国梦的磅礴力量，具有十分重要的意义。为帮助广大干部群众学习、理解、掌握习近平同志的重要论述，中共中央党史和文献研究院编辑了《习近平关于注重家庭家教家风建设论述摘编》。本书内容，摘自习近平同志2012年11月15日至2020年12月28日期间的报告、讲话、谈话、说明、答问等60多篇重要文献，分7个专题，共计107段论述。其中一些论述是第一次公开发表。",
        url: "/book/detail/yoowg",
        wUrl: "/book/detail/yoowg",
      },
      {
        shId: "5oowg",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/909/932/751/61427076.jpg",
        name: "习近平关于网络强国论述摘编",
        author: "中共中央党史和文献研究院编",
        intro:
          "普及本。党的十八大以来，以习近平同志为核心的党中央从进行具有许多新的历史特点的伟大斗争出发，重视互联网、发展互联网、治理互联网，统筹协调涉及政治、经济、文化、社会、军事等领域网络安全和信息化重大问题，作出一系列重大决策、实施一系列重大举措，推动我国网信事业取得历史性成就，走出一条中国特色治网之道。习近平同志围绕网络强国建设发表一系列重要论述，提出一系列新思想新观点新论断，为新时代网信事业发展提供了根本遵循，必须长期坚持贯彻、不断丰富发展。为帮助广大干部群众学习、理解、掌握习近平同志的重要论述，我们编辑了《习近平关于网络强国论述摘编》。本书内容，摘自习近平同志二〇一三年三月四日至二〇二〇年十一月二十三日期间的讲话、报告、演讲、指示、批示、贺信等一百多篇重要文献，分九个专题，共计二百八十五段论述。其中许多论述是第一次公开发表。",
        url: "/book/detail/5oowg",
        wUrl: "/book/detail/5oowg",
      },
      {
        shId: "tJowg",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/906/929/748/61427073.jpg",
        name: "习近平关于统筹疫情防控和经济社会发展重要论述选编",
        author: "中共中央党史和文献研究院编",
        intro:
          "普及本。面对突如其来的新冠肺炎疫情，以习近平同志为核心的党中央坚持把人民生命安全和身体健康放在第一位，统揽全局、果断决策，领导全党全军全国各族人民打响了疫情防控的人民战争、总体战、阻击战。习近平同志亲自指挥、亲自部署，多次主持召开会议并发表重要讲话，作出一系列重要指示批示。经过艰苦卓绝的努力，武汉保卫战、湖北保卫战取得决定性成果，全国抗疫斗争取得重大战略成果，统筹推进疫情防控和经济社会发展工作取得显著成效。为帮助广大干部群众深入学习习近平同志有关重要论述，大力弘扬伟大抗疫精神，做好统筹疫情防控和经济社会发展工作，奋力实现决胜全面建成小康社会、决战脱贫攻坚目标任务，中央党史和文献研究院编辑了《习近平关于统筹疫情防控和经济社会发展重要论述选编》。",
        url: "/book/detail/tJowg",
        wUrl: "/book/detail/tJowg",
      },
    ],
  },
  {
    typeName: "工作足迹",
    resType: 0,
    groupId: 43,
    list: [
      {
        shId: "FPowg",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/113/118/944/61423289.jpg",
        name: "习近平与大学生朋友们",
        author: "《习近平与大学生朋友们》编写组著",
        intro:
          "本书以“当事人讲当年事”的方式，收录了25篇采访实录，全景展现了1983年12月至2019年7月间，习近平同志在不同领导岗位上与青年大学生交流交心交友的故事。三十多年来，习近平同志对青年特别是大学生的关注、关心、关爱始终如一，他勉励大学生们坚定理想信念，不忘初心跟党走，“人生的扣子从一开始就要扣好”，要“真学、真懂、真信、真用”马克思主义，将自己的命运同国家民族的命运“紧紧绑到一起”；他嘱咐大学生们“志存高远、脚踏实地”，“自讨苦吃”，“敢闯新路、敢创新业”，“在社会的广阔天地大显身手”；他寄语大学生们争做自主创新的“排头兵”，“把中华优秀传统文化传播到五湖四海”。通过这些交流，青年学子们深切感受到党的核心、人民领袖对青年一代的亲切关怀和殷切期望，为自己走好人生路指明了正确航向。本书是新时代讲好习近平总书记故事的优秀读本，在《中国青年报》连载后受到青年读者衷心喜爱和社会各界广泛关注。",
        url: "/book/detail/FPowg",
        wUrl: "/book/detail/FPowg",
      },
      {
        shId: "cPowg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/147/140/974/61421329_st_300_400.jpg",
        name: "习近平扶贫故事",
        author: "人民日报海外版编著",
        intro:
          "《习近平扶贫故事》以习近平总书记的扶贫思想的发展为线索，遴选了一系列既脍炙人口又发人深思的故事。从1969年到2020年，习近平总书记的这些故事时间跨度长达半个世纪；从陕西的梁家河、河北的正定，到福建、浙江、上海，再到调任中央，习近平总书记的这些故事几乎涵盖了他的全部从政履历；从十五岁插队初识农村艰苦生活，到走遍全国集中连片特困地区，习近平总书记的这些故事记录了他与困难群众交往、带领困难群众脱贫攻坚的点点滴滴。",
        url: "/book/detail/cPowg",
        wUrl: "/book/detail/cPowg",
      },
      {
        shId: "mTu6j",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/546/172/586/61525416.jpg",
        name: "习近平在浙江（上册）",
        author: "中央党校采访实录编辑室著",
        intro:
          "《习近平在浙江》是反映习近平总书记成长历程的采访实录的第七部，于2021年3月1日至4月21日在《学习时报》连载。此前，《学习时报》已陆续刊发《习近平的七年知青岁月》《习近平在正定》《习近平在厦门》《习近平在宁德》《习近平在福州》《习近平在福建》。2002年10月至2007年3月，习近平同志任浙江省委副书记、代省长（2002年10月）和省委书记（2002年11月）。在履职浙江之前，习近平同志在福建省工作了17年多时间，先后在厦门市、宁德地区、福州市和福建省委、省政府不同层级重要岗位上担任领导职务，经过了经济特区、贫困地区、省会城市和全省领导工作的扎实历练，积累了丰富的领导工作经验。在浙江，习近平同志作为省委书记全面领导了一个经济发达省份的工作，因而在他的地方领导实践中具有关键性的意义。习近平同志在领导浙江转变经济增长方式、建设先进制造业基地、提高对内对外开放水平、统筹城乡发展和区域发展、创建生态省、建设法治浙江和平安浙江、建设文化大省、推进民生实事、加强党的建设等实践中，既充分展现了高超的思想理论水平和宏观决策水平、突出的政治驾驭能力和组织领导能力，也充分展现了深入务实的工作作风和真挚朴实的为民情怀。这部采访实录，通过对当年浙江省委省政府领导同志、省直部门和地市领导干部、基层干部和企业家、专家学者和记者等的访谈，做了生动翔实的现场呈现。",
        url: "/book/detail/mTu6j",
        wUrl: "/book/detail/mTu6j",
      },
    ],
  },
  {
    typeName: "学习读本",
    resType: 0,
    groupId: 42,
    list: [
      {
        id: 1517723,
        assetsId: 61568220,
        shId: "WYeZj",
        overdue: false,
        url: "/book/detail/WYeZj",
        wUrl: "/book/detail/WYeZj",
        name: "习近平新时代中国特色社会主义思想三十讲",
        intro:
          "为了加强广大党员群众对习近平新时代中国特色社会主义思想的理解，中共中央宣传部组织编写本书。本书深入浅出、重点突出，分30个专题对习近平新时代中国特色社会主义思想进行了深入分析和解读阐释，有助于广大党员、干部和群众深刻理解习近平新时代中国特色社会主义思想的丰富内涵。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/479/363/605/61568220_st_300_400.jpg",
        author: "中共中央宣传部编",
        publisher: "学习出版社",
        publishDate: "2018年05月",
        price: "48.00",
        isbn: "978-7-5147-0855-4",
        dueDate: "2025-04-20",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
        id: 1474708,
        assetsId: 61431671,
        shId: "nz0xg",
        overdue: false,
        url: "/book/detail/nz0xg",
        wUrl: "/book/detail/nz0xg",
        name: "习近平总书记在文艺工作座谈会上的重要讲话学习读本",
        intro:
          "2014年10月15日，习近平总书记主持召开文艺工作座谈会，发表了重要讲话。讲话科学分析了文艺领域面临的新形势、新情况、新问题，创造性地回答了事关文艺繁荣发展的一系列带有根本性、方向性的重大问题，体现了党对文艺工作的新思想、新判断、新要求，对在新的历史条件下开创文艺工作新局面作出全面部署。为了深入学习贯彻习近平总书记重要讲话精神，中央宣传部文艺局局组织编写了讲话读本，供广大党员、干部和文艺工作者参考。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/519/572/371/61431671_st_300_400.jpg",
        author: "中共中央宣传部编",
        publisher: "学习出版社",
        publishDate: "2015年10月",
        price: "19.00",
        isbn: "978-7-5147-0574-4",
        dueDate: "2024-09-30",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
        id: 1471375,
        assetsId: 61424259,
        shId: "eoowg",
        overdue: false,
        url: "/book/detail/eoowg",
        wUrl: "/book/detail/eoowg",
        name: "习近平新时代中国特色社会主义思想学习问答",
        intro:
          "本书是按照中央要求，组织专家学者对习近平新时代中国特色社会主义思想所涉及的深层次理论与实践问题，以及党员干部群众关心的热点难题问题，作出深入浅出的权威回答。全书共100个问题，文风生动活泼，准确系统展现了习近平新时代中国特色社会主义思想的核心要义、精神实质、丰富内涵、实践要求，深刻阐明了这一思想的时代意义、理论意义、实践意义、世界意义。在中国共产党成立100周年之际，本书以问答的形式出版，是推动党的创新理论“飞入寻常百姓家”的一项创举，必将进一步推动这一思想通俗化、大众化，进一步推动这一思想入脑入心，更好凝聚起新时代新征程强大的奋进力量。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/86/97/919/61424259_st_300_400.jpg",
        author: "中共中央宣传部编",
        publisher: "学习出版社，人民出版社",
        publishDate: "2021年02月",
        price: "50.00",
        isbn: "978-7-5147-1029-8",
        dueDate: "2024-09-30",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      // {shId:'eoowg',overdue:false,coverImgUrl:'//imgb2.chineseall.cn/bookcover/86/97/919/61424259_st_300_400_1.jpg',name:'习近平新时代中国特色社会主义思想学习问答',author:'中共中央宣传部编',intro:'本书是按照中央要求，组织专家学者对习近平新时代中国特色社会主义思想所涉及的深层次理论与实践问题，以及党员干部群众关心的热点难题问题，作出深入浅出的权威回答。全书共100个问题，文风生动活泼，准确系统展现了习近平新时代中国特色社会主义思想的核心要义、精神实质、丰富内涵、实践要求，深刻阐明了这一思想的时代意义、理论意义、实践意义、世界意义。在中国共产党成立100周年之际，本书以问答的形式出版，是推动党的创新理论“飞入寻常百姓家”的一项创举，必将进一步推动这一思想通俗化、大众化，进一步推动这一思想入脑入心，更好凝聚起新时代新征程强大的奋进力量。',url:'/book/detail/eoowg',wUrl:'/book/detail/eoowg'}
      // ,{shId:'kTu6j',coverImgUrl:'//imgb2.chineseall.cn/bookcover/677/297/715/61524550.jpg',name:'习近平法治思想概论',author:'《习近平法治思想概论》编写组编',intro:'作为我国第一部专门阐述习近平法治思想的马克思主义理论研究和建设工程重点教材，本教材共包括3编20章，对习近平法治思想的重大意义、习近平法治思想的核心要义、习近平法治思想的科学方法等内容进行了详细阐释和权威解读，由点及面、由浅入深，呈现了习近平法治思想的认知起点和解释框架，不仅有助于开好习近平法治思想概论这门课程，还有利于用习近平法治思想统领法学学科体系和教材体系建设，增强法学学科体系和教材体系的中国特色、中国风格、中国气派。',url:'/book/detail/kTu6j',wUrl:'/book/detail/kTu6j'}
      // ,{shId:'GEu6j',coverImgUrl:'//imgb2.chineseall.cn/bookcover/948/826/77/61567692.jpg',name:'习近平法治思想学习纲要',author:'中共中央宣传部，中央全面依法治国委员会办公室编',intro:'根据党中央统一部署，为把学习贯彻习近平新时代中国特色社会主义思想特别是习近平法治思想不断引向深入，中央宣传部、中央依法治国办组织编写了《习近平法治思想学习纲要》（以下简称《纲要》）。《纲要》深刻阐述习近平新时代中国特色社会主义思想在法治领域的原创性贡献，系统宣介习近平法治思想的基本精神、基本内容、基本要求，为广大干部群众深入学习贯彻习近平法治思想提供了辅助读物。各级法治工作部门要结合工作实际组织好本系统党员干部的学习。要坚持全面系统学、及时跟进学、深入思考学、联系实际学，更加自觉用习近平法治思想指导解决实际问题，不断提高运用法治思维和法治方式深化改革、推动发展、化解矛盾、维护稳定应对风险的能力，切实把学习成效转化为推进全面依法治国、建设法治中国的生动实践。',url:'/book/detail/GEu6j',wUrl:'/book/detail/GEu6j'}
    ],
  },
  {
    typeName: "思想研究",
    resType: 0,
    groupId: 44,
    list: [
      {
        shId: "wVowg",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/916/939/758/61427083.jpg",
        name: "习近平新时代中国特色社会主义思想学习论丛（第五辑）",
        author: "中共中央党史和文献研究院编",
        intro:
          "党的十八大以来，中央党史和文献研究院在努力完成好中央交办的编辑出版习近平总书记著作重大政治任务的同时，组织撰写并在《人民日报》、《求是》发表了系列宣传介绍文章。为帮助广大干部群众深刻领会习近平总书记系列著作的精髓要义，系统把握党的十八大以来以习近平同志为核心的党中央理论、实践和制度创新的重大成果，把学习习近平新时代中国特色社会主义思想进一步引向深入，现将这些文章分册结集出版。收入本书时，我们对有些文章的个别文字作了必要的纠正。",
        url: "/book/detail/wVowg",
        wUrl: "/book/detail/wVowg",
      },
      {
        shId: "xTu6j",
        overdue: false,
        coverImgUrl: "//imgb2.chineseall.cn/bookcover/671/285/707/61523547.jpg",
        name: "当代中国马克思主义的最新理论成果：学习习近平新时代中国特色社会主义思想",
        author: "王伟光著",
        intro:
          "党的十九大最重大的贡献，就是提出习近平新时代中国特色社会主义思想，并确立为党与时俱进的指导思想。习近平新时代中国特色社会主义思想，牢牢把握新时代坚持和发展中国特色社会主义这个重大时代课题，系统回答了中国特色社会主义一系列重大问题，指出了一系列重大思想、重要观点、重大战略、重大举措，形成了一个主题鲜明、主线突出、观点创新、逻辑严谨、系统完整的理论体系，是当代中国马克思主义的最新理论成果，是全党全国人民在新时代坚持和发展中国特色社会主义的理论指南和行动纲领。本书主要汇集了中国社会科学院院长王伟光撰写的学习、宣传习近平新时代中国特色社会主义思想系列文章40余篇，具有十分重要的现实意义和出版价值。",
        url: "/book/detail/xTu6j",
        wUrl: "/book/detail/xTu6j",
      },
      {
        shId: "MNu6j",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/336/941/372/61523212_st_300_400.jpg",
        name: "习近平总书记在庆祝中国共产党成立100周年大会上重要讲话精神述评",
        author: "新华通讯社编",
        intro:
          "本书根据习近平总书记“七一”重要讲话的内在逻辑分为五个专题和结语，分别是“1.全面建成小康社会：历史性地解决绝对贫困问题”“2.实现中华民族伟大复兴：党的百年奋斗主题”“3.四个伟大成就：中华民族几千年历史上最恢宏的史诗”“4.伟大建党精神：中国共产党的精神之源”“5.‘九个必须’：开创未来的行动指南”和“结语：吹响向第二个百年目标进军的号角”。全书共收录了新华社公开采写播发的相关报道三十余篇，为方便读者阅读，书中还配有新华社播发的图片数十幅，并根据具体内容设计了“域外声音”“学者观点”等板块，力争准确通俗地阐释习近平总书记重要讲话精神。本书导向正确、内容权威、图文并茂，可以作为广大党员干部深入学习贯彻习近平总书记在庆祝中国共产党成立100周年大会上重要讲话精神的参考读物。",
        url: "/book/detail/MNu6j",
        wUrl: "/book/detail/MNu6j",
      },
    ],
  },
  {
    typeName: "案例选",
    resType: 0,
    groupId: 45,
    list: [
      {
        shId: "SJaHg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/319/589/908/61302858_st_300_400_1.jpg",
        name: "贯彻落实习近平新时代中国特色社会主义思想在改革发展稳定中攻坚克难案例-党的建设",
        author: "中共中央组织部",
        intro:
          "党的十九大报告指出，党要团结带领人民进行伟大斗争、推进伟大事业、实现伟大梦想，必须毫不动摇坚持和完善党的领导，毫不动摇把党建设得更加坚强有力。为帮助广大党员干部全面学习领会习近平新时代中国特色社会主义思想，深刻把握习近平总书记关于新时代党的建设的重要论述，激励干部担当作为，提高干部精准施策的本领，更好地以改革创新精神破解党建难题，中央组织部组织编选了本书。",
        url: "/book/detail/SJaHg",
        wUrl: "/book/detail/SJaHg",
      },
      {
        shId: "3JaHg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/316/586/905/61302855_st_300_400_1.jpg",
        name: "贯彻落实习近平新时代中国特色社会主义思想在改革发展稳定中攻坚克难案例-文化建设",
        author: "中共中央组织部",
        intro:
          "党的十九大报告指出，发展中国特色社会主义文化，就是以马克思主义为指导，坚守中华文化立场，立足当代中国现实，结合当今时代条件，发展面向现代化、面向世界、面向未来的，民族的科学的大众的社会主义文化，推动社会主义精神文明和物质文明协调发展。为帮助广大党员干部全面学习领会习近平新时代中国特色社会主义思想，深刻把握习近平总书记关于文化建设的重要论述，从党的十八大以来文化建设领域攻坚克难的生动案例中深入学习推动中国特色社会主义文化繁荣兴盛的经验做法，激励干部担当作为，提高干部精准施政的本领，中央组织部组织编选了本书。",
        url: "/book/detail/3JaHg",
        wUrl: "/book/detail/3JaHg",
      },
      {
        shId: "ZpaHg",
        overdue: false,
        coverImgUrl:
          "//imgb2.chineseall.cn/bookcover/315/585/904/61302854_st_300_400_1.jpg",
        name: "贯彻落实习近平新时代中国特色社会主义思想在改革发展稳定中攻坚克难案例-政治建设",
        author: "中共中央组织部",
        intro:
          "党的十九大报告指出，要长期坚持、不断发展我国社会主义民主政治，积极稳妥推进政治体制改革，推进社会主义民主政治制度化、规范化、程序化，保证人民依法通过各种途径和形式管理国家事务，管理经济文化事业，管理社会事务，巩固和发展生动活泼、安定团结的政治局面。为帮助广大党员干部全面学习领会习近平新时代中国特色社会主义思想，深刻把握习近平总书记关于新时代中国特色社会主义政治建设的重要论述，从党的十八大以来政治建设领域攻坚克难的生动案例中深入学习发展社会主义民主政治的经验做法，激励干部担当作为，提高干部精准施政的本领，中央组织部组织编写了本书。",
        url: "/book/detail/ZpaHg",
        wUrl: "/book/detail/ZpaHg",
      },
    ],
  },

  {
    typeName: "用语解读",
    resType: 0,
    groupId: 49,
    list: [
      {
        id: 1517978,
        assetsId: 61571588,
        shId: "9SKZj",
        overdue: false,
        url: "/book/detail/9SKZj",
        wUrl: "/book/detail/9SKZj",

        name: "习近平用典（第一辑）",
        intro:
          "本书分为敬民、信念、廉政、法治、修身等13篇，收入习近平2014年9月以前在重要讲话（文章）中引用的135则典故，按主题对典故的现实意义进行解读，对背景义理进行解释，以帮助广大读者准确理解习近平总书记的思想精髓。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/856/758/988/61571588.jpg",
        author: "人民日报评论部编著",
        publisher: "人民日报出版社",
        publishDate: "2018年04月",
        price: "47.00",
        isbn: "978-7-5115-5426-0",
        dueDate: "2024-10-19",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
        id: 1517976,
        assetsId: 61571570,
        shId: "VSKZj",
        overdue: false,
        url: "/book/detail/VSKZj",
        wUrl: "/book/detail/VSKZj",
        name: "习近平讲故事（少年版）",
        intro:
          "《习近平讲故事》（少年版）以人民出版社已出版的成人版《习近平讲故事》为蓝本，在成人版的内容基础上，针对少年儿童特点进行选文。全书分为对内篇和对外篇，共分为9个板块，共收入47篇文章，约5万字左右。分别从廉政、品格、励志、交往等方面对少年儿童进行从小学习做人，学习立志，学习创造的教育，帮助中小学生“系好人生第一个纽扣”，为他们打好精神底色。",
        coverImgUrl:
          "https://imgb2.chineseall.cn/bookcover/838/740/970/61571570_st_300_400.jpg",
        author: "人民日报评论部著",
        publisher: "中国少年儿童新闻出版总社，人民出版社",
        publishDate: "2018年06月",
        price: "37.00",
        isbn: "978-7-5148-4764-2",
        dueDate: "2025-06-27",
        readAll: 1,
        collected: 0,
        pageviews: 0,
        detail: 0,
        readNum: 0,
        readCount: 0,
        statusValue: 1,
      },
      {
    "id": 1514684,
    "assetsId": 61568342,
    "shId": "gzN6j",
     overdue: false,
     "url": "/book/detail/gzN6j",
     "wUrl": "/book/detail/gzN6j",
    "name": "平易近人——习近平的语言力量（外交卷）",
    "intro": "本书是平易近人系列之一，继军事卷之后的习主席外交方面的重要论述。是习近平系列重要讲话的“外交篇”，是习近平主席外交思想的总结，阐述了中国特色大国外交理论体系以及外交布局，是新时期中国外交指南。该书延续之前《平易近人》的写作风格：深入浅出，通俗易懂，是外交人员及相关工作者的必备图书。",
    "coverImgUrl": "https://imgb2.chineseall.cn/bookcover/601/485/727/61568342_st_300_400.jpg",
    "author": "苏格主编",
    "publisher": "上海交通大学出版社",
    "publishDate": "2018年10月",
    "price": "68.00",
    "isbn": "978-7-313-20196-6",
    "dueDate": "2025-05-31",
    "readAll": 1,
    "collected": 0,
    "pageviews": 0,
    "detail": 0,
    "readNum": 0,
    "readCount": 0,
    "statusValue": 1
}
      //  ,{shId:'wNu6j',coverImgUrl:'//imgb2.chineseall.cn/bookcover/951/829/80/61567695.jpg',name:'平“语”近人——习近平喜欢的典故（第二季）',author:'中共中央宣传部，中央广播电视总台编著',intro:'本书是中共中央宣传部、中央广播电视总台联合创作的《百家讲坛》特别节目。节目从习近平总书记一系列重要讲话、文章、谈话中所引用的古代典籍和经典名句为切入点，旨在推动习近平新时代中国特色社会主义思想的生动阐释与广泛传播。节目由“原声微视频”“思想解读”“经典释义”“现场访谈”“互动问答”“经典诵读”六个环节构成。第一季播出以后，引起很好反响。中央电视台又邀请徐川等嘉宾录制了《平“语”近人——习近平喜欢的典故（第二季）》，本书以节目脚本为基础，配上图片和视频，有利于广大党员干部学习贯彻习近平新时代中国特色社会主义思想。',url:'/book/detail/wNu6j',wUrl:'/book/detail/wNu6j'}
    ],
  },
  {
    typeName: "新经典有声书",
    groupId: 495,
    resType: 1,
    list: [
      {
        shId: "YqqZj",
        coverImgUrl:
          "//imgb2.chineseall.cn/audiocover/786/664/910/61567530.jpg",
        name: "习近平新时代中国特色社会主义思想三十讲",
        author: "中共中央宣传部编",
        intro:
          "为了加强广大党员群众对习近平新时代中国特色社会主义思想的理解，中共中央宣传部组织编写本书。本书深入浅出、重点突出，分30个专题对习近平新时代中国特色社会主义思想进行了深入分析和解读阐释，有助于广大党员、干部和群众深刻理解习近平新时代中国特色社会主义思想的丰富内涵。",
        url: "/audio/detail/YqqZj",
        wUrl: "/audio/play/YqqZj",
        pcUrl: "/audio/play/YqqZj",
      },
      {
        shId: "h6zZj",
        coverImgUrl:
          "//imgb2.chineseall.cn/audiocover/790/668/914/61567534.jpg",
        name: "习近平谈治国理政（第三卷）",
        author: "习近平著",
        intro:
          "习近平谈治国理政（第三卷）收入了习近平总书记在2017年10月18日至2020年1月13日期间的报告、讲话、谈话、演讲、批示、指示、贺信等92篇，分为19个专题。",
        url: "/audio/detail/h6zZj",
        wUrl: "/audio/play/h6zZj",
        pcUrl: "/audio/play/h6zZj",
      },
      {
        shId: "6Esvj",
        coverImgUrl:
          "//imgb2.chineseall.cn/audiocover/162/647/158/61503098.jpg",
        name: "在全国组织工作会议上的讲话",
        author: "习近平著",
        intro:
          "习近平同志在讲话中全面回顾了党的十八大以来党的建设和组织工作成就，明确了新时代党的建设和党的组织路线，着重从以组织体系建设为重点、着力培养忠诚干净担当的高素质干部、着力集聚爱国奉献的各方面优秀人才、做好年轻干部工作这四个方面，阐述了新时代的党建工作任务。习近平同志指出，着力培养忠诚干净担当的高素质干部，需要建立素质培养体系、知事识人体系、选拔任用体系、从严管理体系和正向激励体系。",
        url: "/audio/detail/6Esvj",
        wUrl: "/audio/play/6Esvj",
        pcUrl: "/audio/play/6Esvj",
      },
    ],
  },
];
